module.exports = __webpack_public_path__ + "img/icon_tab2.aab49c42.png";